export default __webpack_public_path__ + "static/media/VeggieFruit_03.02108223.png";